<template>
    <div class="email-stats-right-sidebar" :class="{ 'show-sidebar': showEmailStats }">
        <section
            v-for="(emailStat, index) in emailStatsRows"
            :key="index"
            class="stats-container"
        >
            <span class="stat-title">
                {{ emailStat.title }}
            </span>
            <div v-for="(stat) in emailStat.data" :key="stat.label" class="cell-wrapper">
                <DsIcon
                    data-qa="merge-field-button"
                    :name="stat.icon"
                    class="cell-icon"
                />
                <div class="wrapper-label">
                    <span class="cell-label">
                        {{ stat.label }}
                    </span>
                    <span class="percentage-sub-text">
                        {{ stat.subText ? stat.subText : "" }}
                    </span>
                </div>

                <span class="cell-value">
                    {{ stat.value }}
                </span>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'KonvaEmailStats',
    props: {
        reportEmailStats: {
            type: Object,
            default: () => ({}),
        },
        preset: {
            type: String,
            required: true,
        },
        showEmailStats: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        emailStatsRows() {
            try {
                if (!Array.isArray(this.reportEmailStats.data)) {
                    // eslint-disable-next-line no-console
                    console.error('this.reportEmailStats.data is not an array');

                    return [];
                }

                return this.reportEmailStats.data.map((item) => {
                    const presetData = [];
                    const contentViewData = item.cardContentViews[this.preset];

                    if (Array.isArray(contentViewData)) {
                        contentViewData.map((stat) => presetData.push(this.formatEmailStatDetails(stat)));
                    } else {
                        // eslint-disable-next-line no-console
                        console.error(`contentViewData is not an array for preset: ${this.preset}`);
                    }

                    return {
                        title: item.title,
                        data: presetData,
                    };
                });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error fetching or processing data:', error);

                return {};
            }
        },
    },
    methods: {
        formatEmailStatDetails(stat) {
            let result = {};
            let extraction = {};

            switch (stat.label) {
            case 'Sent':
                result = { icon: 'send', label: this.$t('campaign.reporting.sidebar.email.stats.sent.emails'), value: stat.value };
                break;

            case 'Delivered':
                result = { icon: 'inbox', label: this.$t('campaign.reporting.sidebar.email.stats.delivered.emails'), value: stat.value };
                break;

            case 'Opens':
                extraction = this.extractNumericValues(stat.value);
                result = {
                    icon: 'email-open', label: this.$t('campaign.reporting.sidebar.email.stats.opens'), value: extraction.firstValue, subText: extraction.subTextLabel,
                };
                break;

            case 'Clicks':
                extraction = this.extractNumericValues(stat.value);
                result = {
                    icon: 'cursor-click', label: this.$t('campaign.reporting.sidebar.email.stats.clicks'), value: extraction.firstValue, subText: extraction.subTextLabel,
                };
                break;

            case 'Opt-Outs':
                extraction = this.extractNumericValues(stat.value);
                result = {
                    icon: 'x', label: this.$t('campaign.reporting.sidebar.email.stats.opt.outs'), value: extraction.firstValue, subText: extraction.subTextLabel,
                };
                break;

            default:
                result = {};
                break;
            }

            return result;
        },
        extractNumericValues(inputString) {
            const regex = /(\d+) \(([\d.]+%)\)/;
            const matches = inputString.match(regex);

            let firstValue = '';
            let secondValue = '';

            if (matches) {
                [, firstValue, secondValue] = matches;
            }
            const subTextLabel = `${secondValue} of total sent`;

            return { firstValue, subTextLabel };
        },
    },
};
</script>

<style scoped lang="scss">
.stat-title {
    font-size: px-to-rem(14px);
    font-weight: 500;
    margin-left: $spacing-200;
}

.stats-container {
    padding-top: $spacing-300;
}

.cell-icon {
    padding-left: $spacing-200;
    width: $spacing-500;
    height: $spacing-500;
}

.wrapper-label {
    display: flex;
    flex-direction: column;
    padding-left: $spacing-200;
}

.cell-label {
    font-size: $font-size-lg;
    margin: 0;
}

.percentage-sub-text {
    font-weight: 400;
    font-size: px-to-rem(14px);
    line-height: $spacing-250;
}

.cell-value {
    color: $color-blue-700;
    text-align: right;
    font-weight: 400;
}

.cell-subtext {
    font-size: $font-size-sm;
    margin-top: $spacing-100;
}

.cell-wrapper {
    display: grid;
    grid-template-columns: px-to-rem(64px) px-to-rem(192px) px-to-rem(96px);
    grid-template-rows: auto;
    margin-top: $spacing-200;
    height: px-to-rem(64px);
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 20%;
        bottom: 0;
        width: 80%;
        border-bottom: 1px solid $color-gray-400;
    }
}

.email-stats-right-sidebar {
    font-family: "Sul Sans";
    font-size: $spacing-200;
    position: relative;
    width: 390px;
    border-left: 1px solid $color-gray-400;
    background-color: white;
    z-index: 10;
    max-height: 90vh;
    overflow-y: auto;
}
</style>
